import { jsx as _jsx } from "preact/jsx-runtime";
import { Controller } from 'react-hook-form';
import { TextBox } from '../common/TextBox';
export function TextBoxField({ control, name, rules, error: errorOverride, ...textBoxProps }) {
    return (_jsx(Controller, { control: control, name: name, rules: rules, render: ({ field, fieldState }) => (_jsx(TextBox, { ...textBoxProps, name: field.name, value: typeof field.value === 'string' ? field.value : (field.value ?? '').toString(), onChange: field.onChange, onBlur: field.onBlur, error: errorOverride ?? fieldState.error?.message })) }));
}
